export default "__VITE_ASSET__BmUm$qT0__"